import * as React from 'react';
import { Select } from '../../ui/Select';
import { GetAllAvids } from '../../util';
import { IAvid } from '../interfaces';

interface IAvidSelectProps {
  value: string
  onChange: (newValue: string) => void
  label?: string
  required?: boolean
  readOnly?: boolean
  includeRootElement?: boolean
}

interface IAvidSelectState {
  avids: IAvid[]
}

export class AvidSelect extends React.Component<IAvidSelectProps, IAvidSelectState> {
  state: IAvidSelectState = {
    avids: []
  }

  componentWillMount() {
    GetAllAvids().then((avids) => {
      if (this.props.includeRootElement) {
        avids.push({
          avid: '-1',
          avidType: 10,
          childInputIdField: '',
          childLabelIdField: '',
          clientsid: '-1',
          dynamicChildren: 0,
          hierarchylevel: 'Bankwide_0',
          label: 'ROOT',
          lastSurvey: '',
          parentid: '-1',
        })
      }
      this.setState({ avids })
    })
  }

  render() {
    const { value, onChange, required, readOnly, label = 'Avid' } = this.props
    const { avids } = this.state

    return (
      <Select<IAvid, 'avid'>
        label={label}
        options={avids}
        value={value}
        required={required}
        loading={avids.length <= 0}
        valueKey="avid"
        labelKey="label"
        readOnly={readOnly}
        onChange={(newValue) => onChange(newValue)} />
    )
  }
}
